import type { Address } from '@/lib/services/addresses/addresses.types'
import { getLocationName } from '@/lib/services/locations/locations.utils'

/** A `Location` offered in a POS location picker. */
interface PosLocationOption {
  id: number
  is_default: boolean
  address?: Pick<Address, 'name' | 'line1'> | null
}

export function getPosLocationOptionLabel(location: PosLocationOption): string {
  return `${getLocationName(location)}${location.is_default ? ' (Default)' : ''}`
}
